import {HttpClientRetryConfig} from './HttpCustomRetry.types';

import {HttpStatus} from '@specials/project-user';

export const IDEMPOTENCY_HEADER_KEY = 'X-Idempotency-Key';
export const RETRY_ABLE_HTTP_STATUSES = [HttpStatus.INTERNAL_SERVER_ERROR, HttpStatus.TOO_MANY_REQUESTS];

// Время задержки для следующего запроса рассчитывается
// по формуле Math.pow(retries * delayInMs, timeBetweenRetryExponent)
// где retries это номер попытки
// при default параметрах калькуляция выходит следующая
// 1 повтор - задержка 400мc
// 2 повтор - задержка 1000мc
// 3 повтор - задержка 1600мc
export const DEFAULT_RETRY_CONFIG: HttpClientRetryConfig = {
  timeBetweenRetryExponent: 1.3,
  delayInMs: 100,
  retryMaxLimit: 3,
};
